import {useEffect} from 'react'

export const useUnsavedChangesWarning = (enabled: boolean): void => {
  useEffect(() => {
    if (!enabled) {
      return
    }
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      return '' // navigateurs anciens
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [enabled])
}
